// @generated by protoc-gen-es v2.12.1 with parameter "target=ts,json_types=true"
// @generated from file integrations/v1/connector.proto (package integrations.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file integrations/v1/connector.proto.
 */
export const file_integrations_v1_connector: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
	);

/**
 * @generated from enum integrations.v1.ConnectorType
 */
export enum ConnectorType {
	/**
	 * @generated from enum value: CONNECTOR_TYPE_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ACTIVECAMPAIGN = 1;
	 */
	ACTIVECAMPAIGN = 1,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_AFTERPAY = 2;
	 */
	AFTERPAY = 2,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_AFTERSHIP = 3;
	 */
	AFTERSHIP = 3,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_AIRSHIP = 4;
	 */
	AIRSHIP = 4,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ALASCO = 5;
	 */
	ALASCO = 5,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ALGOLIA = 6;
	 */
	ALGOLIA = 6,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_AMADEUS_OAUTH = 7;
	 */
	AMADEUS_OAUTH = 7,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_AMAZON = 8;
	 */
	AMAZON = 8,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ANKORED = 9;
	 */
	ANKORED = 9,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ANTHROPIC = 10;
	 */
	ANTHROPIC = 10,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_APOLLO_IO = 11;
	 */
	APOLLO_IO = 11,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_APPSIGNAL = 12;
	 */
	APPSIGNAL = 12,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ASKNICELY = 13;
	 */
	ASKNICELY = 13,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ASSEMBLED = 14;
	 */
	ASSEMBLED = 14,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ATTENTIVE = 15;
	 */
	ATTENTIVE = 15,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_AWS = 16;
	 */
	AWS = 16,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_AZURE_DEVOPS = 17;
	 */
	AZURE_DEVOPS = 17,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_AZURE_PAT = 18;
	 */
	AZURE_PAT = 18,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_BAMBOOHR = 19;
	 */
	BAMBOOHR = 19,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_BANDCAMP = 20;
	 */
	BANDCAMP = 20,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_BASIC_LOGIN = 21;
	 */
	BASIC_LOGIN = 21,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_BAZAARVOICE = 22;
	 */
	BAZAARVOICE = 22,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_BIGCOMMERCE = 23;
	 */
	BIGCOMMERCE = 23,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_BITBUCKET = 24;
	 */
	BITBUCKET = 24,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_BLOOMREACH = 25;
	 */
	BLOOMREACH = 25,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_BOOKER_CUSTOMER = 26;
	 */
	BOOKER_CUSTOMER = 26,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_BOOKER_MERCHANT = 27;
	 */
	BOOKER_MERCHANT = 27,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_BOX = 28;
	 */
	BOX = 28,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_BRAZE = 29;
	 */
	BRAZE = 29,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_BRIGHTPEARL_OAUTH = 30;
	 */
	BRIGHTPEARL_OAUTH = 30,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_BRIGHTPEARL_STAFF = 31;
	 */
	BRIGHTPEARL_STAFF = 31,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_CAMPAIGN_MONITOR = 32;
	 */
	CAMPAIGN_MONITOR = 32,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_CAMPAIGN_MONITOR_OAUTH = 33;
	 */
	CAMPAIGN_MONITOR_OAUTH = 33,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_CAPABL = 34;
	 */
	CAPABL = 34,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_CHARGEBEE = 35;
	 */
	CHARGEBEE = 35,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_CHARGIFY = 36;
	 */
	CHARGIFY = 36,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_CHUBB = 37;
	 */
	CHUBB = 37,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_CIN7 = 38;
	 */
	CIN7 = 38,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_CLOUDBEDS = 39;
	 */
	CLOUDBEDS = 39,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_CLOVER = 40;
	 */
	CLOVER = 40,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_COACHPACKET = 41;
	 */
	COACHPACKET = 41,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_COHERE = 42;
	 */
	COHERE = 42,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_COMPLYT = 43;
	 */
	COMPLYT = 43,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_CONNECTSPORTS = 44;
	 */
	CONNECTSPORTS = 44,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_CONSTANT_CONTACT = 45;
	 */
	CONSTANT_CONTACT = 45,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_CUSTOMERTHERMOMETER = 46;
	 */
	CUSTOMERTHERMOMETER = 46,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_DATADOG = 47;
	 */
	DATADOG = 47,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_DATEV = 48;
	 */
	DATEV = 48,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_DATEV_OAUTH = 49;
	 */
	DATEV_OAUTH = 49,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_DAYFORCE = 50;
	 */
	DAYFORCE = 50,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_DELIGHTED = 51;
	 */
	DELIGHTED = 51,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_DHL = 52;
	 */
	DHL = 52,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_DHL_UNIFIED = 53;
	 */
	DHL_UNIFIED = 53,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_DOMO = 54;
	 */
	DOMO = 54,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_DOTDIGITAL = 55;
	 */
	DOTDIGITAL = 55,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_DRIP = 56;
	 */
	DRIP = 56,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_DROPBOX = 57;
	 */
	DROPBOX = 57,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_DYNAMICYIELD = 58;
	 */
	DYNAMICYIELD = 58,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_EASYSHIP = 59;
	 */
	EASYSHIP = 59,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ELOQUA = 60;
	 */
	ELOQUA = 60,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_EMOTIVE = 61;
	 */
	EMOTIVE = 61,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ENDEAR = 62;
	 */
	ENDEAR = 62,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ENVISION = 63;
	 */
	ENVISION = 63,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ETIP = 64;
	 */
	ETIP = 64,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ETRIBEZ = 65;
	 */
	ETRIBEZ = 65,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_EVALUAGENT = 66;
	 */
	EVALUAGENT = 66,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_EXACT_ONLINE = 67;
	 */
	EXACT_ONLINE = 67,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_EZCOM = 68;
	 */
	EZCOM = 68,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_FABRIC = 69;
	 */
	FABRIC = 69,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_FACEBOOK = 70;
	 */
	FACEBOOK = 70,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_FACEBOOK_FBE = 71;
	 */
	FACEBOOK_FBE = 71,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_FALCON_IO = 72;
	 */
	FALCON_IO = 72,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_FAMER = 73;
	 */
	FAMER = 73,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_FEDEX = 74;
	 */
	FEDEX = 74,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_FIELD_NATION = 75;
	 */
	FIELD_NATION = 75,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_FINCH = 76;
	 */
	FINCH = 76,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_FIVETRAN = 77;
	 */
	FIVETRAN = 77,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_FLEETIO = 78;
	 */
	FLEETIO = 78,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_FLOWCODE = 79;
	 */
	FLOWCODE = 79,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_FLOWCODE_OAUTH = 80;
	 */
	FLOWCODE_OAUTH = 80,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_FLUINCY = 81;
	 */
	FLUINCY = 81,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_FOLLOW_UP_BOSS = 82;
	 */
	FOLLOW_UP_BOSS = 82,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_FOLLOW_UP_BOSS_OAUTH = 83;
	 */
	FOLLOW_UP_BOSS_OAUTH = 83,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_FORTNOX_OAUTH = 84;
	 */
	FORTNOX_OAUTH = 84,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_FOUNDATION_SOFT = 85;
	 */
	FOUNDATION_SOFT = 85,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_FULFIL = 86;
	 */
	FULFIL = 86,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_FULFIL_3PL = 87;
	 */
	FULFIL_3PL = 87,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_GENERIC_BASIC = 88;
	 */
	GENERIC_BASIC = 88,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_GETRESPONSE = 89;
	 */
	GETRESPONSE = 89,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_GITHUB = 90;
	 */
	GITHUB = 90,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_GITLAB = 91;
	 */
	GITLAB = 91,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_GLADLY = 92;
	 */
	GLADLY = 92,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_GOHIGHLEVEL = 93;
	 */
	GOHIGHLEVEL = 93,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_GONG = 94;
	 */
	GONG = 94,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_GONG_OAUTH = 95;
	 */
	GONG_OAUTH = 95,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_GOOGLE = 96;
	 */
	GOOGLE = 96,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_GOOGLE_GEMINI = 97;
	 */
	GOOGLE_GEMINI = 97,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_GOOGLE_SERVICE_ACCOUNT = 98;
	 */
	GOOGLE_SERVICE_ACCOUNT = 98,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_GOOTEN = 99;
	 */
	GOOTEN = 99,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_GORGIAS = 100;
	 */
	GORGIAS = 100,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_GORGIAS_OAUTH = 101;
	 */
	GORGIAS_OAUTH = 101,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_GREENHOUSE_IO_CANDIDATE_INGESTION = 102;
	 */
	GREENHOUSE_IO_CANDIDATE_INGESTION = 102,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_GREENHOUSE_IO_HARVEST = 103;
	 */
	GREENHOUSE_IO_HARVEST = 103,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_GREENHOUSE_IO_JOB_BOARD = 104;
	 */
	GREENHOUSE_IO_JOB_BOARD = 104,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_GWT = 105;
	 */
	GWT = 105,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_HAPPYRETURNS = 106;
	 */
	HAPPYRETURNS = 106,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_HEARTLAND = 107;
	 */
	HEARTLAND = 107,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_HOOTSUITE = 108;
	 */
	HOOTSUITE = 108,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_HOTSOS = 109;
	 */
	HOTSOS = 109,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_HS = 110;
	 */
	HS = 110,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_HUBSPOT_BASIC = 111;
	 */
	HUBSPOT_BASIC = 111,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_HUBSPOT_OAUTH = 112;
	 */
	HUBSPOT_OAUTH = 112,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_HUGGING_FACE = 113;
	 */
	HUGGING_FACE = 113,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_IMAGERELAY = 114;
	 */
	IMAGERELAY = 114,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_IMGUR = 115;
	 */
	IMGUR = 115,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ITERABLE = 116;
	 */
	ITERABLE = 116,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_JASPER = 117;
	 */
	JASPER = 117,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_JDP = 118;
	 */
	JDP = 118,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_JUSTUNO = 119;
	 */
	JUSTUNO = 119,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_KENTICO_KONTENT = 120;
	 */
	KENTICO_KONTENT = 120,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_KLAUS = 121;
	 */
	KLAUS = 121,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_KLAVIYO = 122;
	 */
	KLAVIYO = 122,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_KLAVIYO_OAUTH = 123;
	 */
	KLAVIYO_OAUTH = 123,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_KOMBO = 124;
	 */
	KOMBO = 124,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_KUSTOMER = 125;
	 */
	KUSTOMER = 125,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_KVCORE = 126;
	 */
	KVCORE = 126,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_LAUNCHDARKLY_SDK = 127;
	 */
	LAUNCHDARKLY_SDK = 127,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_LEAGUEAPPS = 128;
	 */
	LEAGUEAPPS = 128,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_LEAGUEAPPS_DEV1 = 129;
	 */
	LEAGUEAPPS_DEV1 = 129,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_LESSONLY = 130;
	 */
	LESSONLY = 130,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_LEXOFFICE = 131;
	 */
	LEXOFFICE = 131,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_LINGA_ROS = 132;
	 */
	LINGA_ROS = 132,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_LINNWORKS = 133;
	 */
	LINNWORKS = 133,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_LISTRAK_CROSS_CHANNEL = 134;
	 */
	LISTRAK_CROSS_CHANNEL = 134,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_LISTRAK_DATA = 135;
	 */
	LISTRAK_DATA = 135,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_LISTRAK_EMAIL = 136;
	 */
	LISTRAK_EMAIL = 136,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_LISTRAK_SMS = 137;
	 */
	LISTRAK_SMS = 137,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_LOOPRETURNS = 138;
	 */
	LOOPRETURNS = 138,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_LOYALTY_LION = 139;
	 */
	LOYALTY_LION = 139,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_LOYALTY_LION_OAUTH = 140;
	 */
	LOYALTY_LION_OAUTH = 140,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_LUCIDTRAVEL = 141;
	 */
	LUCIDTRAVEL = 141,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_LYTX = 142;
	 */
	LYTX = 142,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_LYTX_OAUTH2 = 143;
	 */
	LYTX_OAUTH2 = 143,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_MAESTROQA = 144;
	 */
	MAESTROQA = 144,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_MAGENTO_OAUTH = 145;
	 */
	MAGENTO_OAUTH = 145,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_MAILCHIMP = 146;
	 */
	MAILCHIMP = 146,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_MARKETO = 147;
	 */
	MARKETO = 147,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_MEDALLIA = 148;
	 */
	MEDALLIA = 148,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_MICROSOFT_ENTRA = 149;
	 */
	MICROSOFT_ENTRA = 149,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_MINDBODY = 150;
	 */
	MINDBODY = 150,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_MINTSOFT = 151;
	 */
	MINTSOFT = 151,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_MISTRAL_AI = 152;
	 */
	MISTRAL_AI = 152,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_MOVO_AI = 153;
	 */
	MOVO_AI = 153,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_NCSA = 154;
	 */
	NCSA = 154,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_NETOMI = 155;
	 */
	NETOMI = 155,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_NETSUITE = 156;
	 */
	NETSUITE = 156,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_NEVERBOUNCE = 157;
	 */
	NEVERBOUNCE = 157,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_NICEREPLY = 158;
	 */
	NICEREPLY = 158,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_NYLAS = 159;
	 */
	NYLAS = 159,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_OMNISEND = 160;
	 */
	OMNISEND = 160,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ONPAY = 161;
	 */
	ONPAY = 161,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ONPAY_SB1 = 162;
	 */
	ONPAY_SB1 = 162,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ONRAMP = 163;
	 */
	ONRAMP = 163,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ONTRAPORT = 164;
	 */
	ONTRAPORT = 164,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_OPENAI = 165;
	 */
	OPENAI = 165,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_OPTIMIZELY_DATA_PLATFORM = 166;
	 */
	OPTIMIZELY_DATA_PLATFORM = 166,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_PANDIUM = 167;
	 */
	PANDIUM = 167,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_PANDIUM_V2 = 168;
	 */
	PANDIUM_V2 = 168,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_PAYCOM = 169;
	 */
	PAYCOM = 169,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_PERPLEXITY = 170;
	 */
	PERPLEXITY = 170,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_PERSONIO = 171;
	 */
	PERSONIO = 171,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_PERSPECTIVE = 172;
	 */
	PERSPECTIVE = 172,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_PLAYERSHEALTH = 173;
	 */
	PLAYERSHEALTH = 173,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_PLAYVOX = 174;
	 */
	PLAYVOX = 174,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_PLEO = 175;
	 */
	PLEO = 175,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_POSTSCRIPT = 176;
	 */
	POSTSCRIPT = 176,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_PROMOTER = 177;
	 */
	PROMOTER = 177,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_QBO = 178;
	 */
	QBO = 178,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_QBO_BASIC = 179;
	 */
	QBO_BASIC = 179,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_QUALTRICS = 180;
	 */
	QUALTRICS = 180,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_RECART = 181;
	 */
	RECART = 181,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_RECHARGE = 182;
	 */
	RECHARGE = 182,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_RECURLY = 183;
	 */
	RECURLY = 183,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_REPLICATE = 184;
	 */
	REPLICATE = 184,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_RETURNLY = 185;
	 */
	RETURNLY = 185,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_REVERSELOGIX = 186;
	 */
	REVERSELOGIX = 186,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_RHUB = 187;
	 */
	RHUB = 187,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_RYDER_REDUX = 188;
	 */
	RYDER_REDUX = 188,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SAGE_INTACCT = 189;
	 */
	SAGE_INTACCT = 189,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SAILTHRU = 190;
	 */
	SAILTHRU = 190,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SALESFORCE = 191;
	 */
	SALESFORCE = 191,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SALESFORCE_MARKETING_CLOUD = 192;
	 */
	SALESFORCE_MARKETING_CLOUD = 192,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SALESFORCE_PARDOT = 193;
	 */
	SALESFORCE_PARDOT = 193,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SCHEMATIC = 194;
	 */
	SCHEMATIC = 194,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SENDGRID = 195;
	 */
	SENDGRID = 195,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SENDLANE = 196;
	 */
	SENDLANE = 196,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SEVENROOMS = 197;
	 */
	SEVENROOMS = 197,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SFTP = 198;
	 */
	SFTP = 198,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SHIPBOB = 199;
	 */
	SHIPBOB = 199,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SHIPHERO = 200;
	 */
	SHIPHERO = 200,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SHIPMONK = 201;
	 */
	SHIPMONK = 201,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SHIPPO = 202;
	 */
	SHIPPO = 202,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SHIPSTATION = 203;
	 */
	SHIPSTATION = 203,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SHOPIFY = 204;
	 */
	SHOPIFY = 204,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SKUBANA = 205;
	 */
	SKUBANA = 205,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SKUBANA_DEMO = 206;
	 */
	SKUBANA_DEMO = 206,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SLACK_OAUTH = 207;
	 */
	SLACK_OAUTH = 207,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SMARTRMAIL = 208;
	 */
	SMARTRMAIL = 208,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SMARTRR = 209;
	 */
	SMARTRR = 209,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SMARTVATTEN = 210;
	 */
	SMARTVATTEN = 210,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SMILE_IO = 211;
	 */
	SMILE_IO = 211,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SOLIDUS = 212;
	 */
	SOLIDUS = 212,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SOURCE_CONTROL = 213;
	 */
	SOURCE_CONTROL = 213,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SPRINGBIG = 214;
	 */
	SPRINGBIG = 214,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SQUARE = 215;
	 */
	SQUARE = 215,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SQUARE_SANDBOX = 216;
	 */
	SQUARE_SANDBOX = 216,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_STAMPED = 217;
	 */
	STAMPED = 217,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_STELLACONNECT = 218;
	 */
	STELLACONNECT = 218,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_STRIPE = 219;
	 */
	STRIPE = 219,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SUGARCRM = 220;
	 */
	SUGARCRM = 220,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SUPABASE_DATA = 221;
	 */
	SUPABASE_DATA = 221,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SUPABASE_DIRECT = 222;
	 */
	SUPABASE_DIRECT = 222,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_SWELL = 223;
	 */
	SWELL = 223,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_TALKABLE = 224;
	 */
	TALKABLE = 224,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_TEAMGENIUS = 225;
	 */
	TEAMGENIUS = 225,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_TETHER = 226;
	 */
	TETHER = 226,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_THANKFUL = 227;
	 */
	THANKFUL = 227,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_TIKTOK = 228;
	 */
	TIKTOK = 228,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_TOAST_OAUTH = 229;
	 */
	TOAST_OAUTH = 229,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_TOGETHER_AI = 230;
	 */
	TOGETHER_AI = 230,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_TRINET_B2B = 231;
	 */
	TRINET_B2B = 231,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_TRINET_END_USER = 232;
	 */
	TRINET_END_USER = 232,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_TRIPLEWHALE = 233;
	 */
	TRIPLEWHALE = 233,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_TRUSTPILOT = 234;
	 */
	TRUSTPILOT = 234,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_TRUSTPILOT_CLIENT = 235;
	 */
	TRUSTPILOT_CLIENT = 235,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_TWILIO = 236;
	 */
	TWILIO = 236,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_TWITTER_BASIC = 237;
	 */
	TWITTER_BASIC = 237,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_TWITTER_OAUTH = 238;
	 */
	TWITTER_OAUTH = 238,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_UKG_PRO = 239;
	 */
	UKG_PRO = 239,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_UNBABEL = 240;
	 */
	UNBABEL = 240,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_UPS = 241;
	 */
	UPS = 241,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_UPSCRIBE = 242;
	 */
	UPSCRIBE = 242,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_USPS = 243;
	 */
	USPS = 243,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_VISMA = 244;
	 */
	VISMA = 244,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_VISMA_NET = 245;
	 */
	VISMA_NET = 245,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_WALMART = 246;
	 */
	WALMART = 246,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_WALMART_OAUTH = 247;
	 */
	WALMART_OAUTH = 247,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_WATTLINE = 248;
	 */
	WATTLINE = 248,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_WHIPLASH = 249;
	 */
	WHIPLASH = 249,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_WHIPLASH_CLIENT = 250;
	 */
	WHIPLASH_CLIENT = 250,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_WIX = 251;
	 */
	WIX = 251,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_WORKMAX = 252;
	 */
	WORKMAX = 252,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_XERO = 253;
	 */
	XERO = 253,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_YARDSTIK = 254;
	 */
	YARDSTIK = 254,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_YOTPO = 255;
	 */
	YOTPO = 255,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ZENDESK_OAUTH = 256;
	 */
	ZENDESK_OAUTH = 256,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ZEROBOUNCE = 257;
	 */
	ZEROBOUNCE = 257,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ZINGTREE = 258;
	 */
	ZINGTREE = 258,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ZONOS = 259;
	 */
	ZONOS = 259,

	/**
	 * @generated from enum value: CONNECTOR_TYPE_ZOOM = 260;
	 */
	ZOOM = 260,
}

/**
 * @generated from enum integrations.v1.ConnectorType
 */
export type ConnectorTypeJson =
	| "CONNECTOR_TYPE_UNSPECIFIED"
	| "CONNECTOR_TYPE_ACTIVECAMPAIGN"
	| "CONNECTOR_TYPE_AFTERPAY"
	| "CONNECTOR_TYPE_AFTERSHIP"
	| "CONNECTOR_TYPE_AIRSHIP"
	| "CONNECTOR_TYPE_ALASCO"
	| "CONNECTOR_TYPE_ALGOLIA"
	| "CONNECTOR_TYPE_AMADEUS_OAUTH"
	| "CONNECTOR_TYPE_AMAZON"
	| "CONNECTOR_TYPE_ANKORED"
	| "CONNECTOR_TYPE_ANTHROPIC"
	| "CONNECTOR_TYPE_APOLLO_IO"
	| "CONNECTOR_TYPE_APPSIGNAL"
	| "CONNECTOR_TYPE_ASKNICELY"
	| "CONNECTOR_TYPE_ASSEMBLED"
	| "CONNECTOR_TYPE_ATTENTIVE"
	| "CONNECTOR_TYPE_AWS"
	| "CONNECTOR_TYPE_AZURE_DEVOPS"
	| "CONNECTOR_TYPE_AZURE_PAT"
	| "CONNECTOR_TYPE_BAMBOOHR"
	| "CONNECTOR_TYPE_BANDCAMP"
	| "CONNECTOR_TYPE_BASIC_LOGIN"
	| "CONNECTOR_TYPE_BAZAARVOICE"
	| "CONNECTOR_TYPE_BIGCOMMERCE"
	| "CONNECTOR_TYPE_BITBUCKET"
	| "CONNECTOR_TYPE_BLOOMREACH"
	| "CONNECTOR_TYPE_BOOKER_CUSTOMER"
	| "CONNECTOR_TYPE_BOOKER_MERCHANT"
	| "CONNECTOR_TYPE_BOX"
	| "CONNECTOR_TYPE_BRAZE"
	| "CONNECTOR_TYPE_BRIGHTPEARL_OAUTH"
	| "CONNECTOR_TYPE_BRIGHTPEARL_STAFF"
	| "CONNECTOR_TYPE_CAMPAIGN_MONITOR"
	| "CONNECTOR_TYPE_CAMPAIGN_MONITOR_OAUTH"
	| "CONNECTOR_TYPE_CAPABL"
	| "CONNECTOR_TYPE_CHARGEBEE"
	| "CONNECTOR_TYPE_CHARGIFY"
	| "CONNECTOR_TYPE_CHUBB"
	| "CONNECTOR_TYPE_CIN7"
	| "CONNECTOR_TYPE_CLOUDBEDS"
	| "CONNECTOR_TYPE_CLOVER"
	| "CONNECTOR_TYPE_COACHPACKET"
	| "CONNECTOR_TYPE_COHERE"
	| "CONNECTOR_TYPE_COMPLYT"
	| "CONNECTOR_TYPE_CONNECTSPORTS"
	| "CONNECTOR_TYPE_CONSTANT_CONTACT"
	| "CONNECTOR_TYPE_CUSTOMERTHERMOMETER"
	| "CONNECTOR_TYPE_DATADOG"
	| "CONNECTOR_TYPE_DATEV"
	| "CONNECTOR_TYPE_DATEV_OAUTH"
	| "CONNECTOR_TYPE_DAYFORCE"
	| "CONNECTOR_TYPE_DELIGHTED"
	| "CONNECTOR_TYPE_DHL"
	| "CONNECTOR_TYPE_DHL_UNIFIED"
	| "CONNECTOR_TYPE_DOMO"
	| "CONNECTOR_TYPE_DOTDIGITAL"
	| "CONNECTOR_TYPE_DRIP"
	| "CONNECTOR_TYPE_DROPBOX"
	| "CONNECTOR_TYPE_DYNAMICYIELD"
	| "CONNECTOR_TYPE_EASYSHIP"
	| "CONNECTOR_TYPE_ELOQUA"
	| "CONNECTOR_TYPE_EMOTIVE"
	| "CONNECTOR_TYPE_ENDEAR"
	| "CONNECTOR_TYPE_ENVISION"
	| "CONNECTOR_TYPE_ETIP"
	| "CONNECTOR_TYPE_ETRIBEZ"
	| "CONNECTOR_TYPE_EVALUAGENT"
	| "CONNECTOR_TYPE_EXACT_ONLINE"
	| "CONNECTOR_TYPE_EZCOM"
	| "CONNECTOR_TYPE_FABRIC"
	| "CONNECTOR_TYPE_FACEBOOK"
	| "CONNECTOR_TYPE_FACEBOOK_FBE"
	| "CONNECTOR_TYPE_FALCON_IO"
	| "CONNECTOR_TYPE_FAMER"
	| "CONNECTOR_TYPE_FEDEX"
	| "CONNECTOR_TYPE_FIELD_NATION"
	| "CONNECTOR_TYPE_FINCH"
	| "CONNECTOR_TYPE_FIVETRAN"
	| "CONNECTOR_TYPE_FLEETIO"
	| "CONNECTOR_TYPE_FLOWCODE"
	| "CONNECTOR_TYPE_FLOWCODE_OAUTH"
	| "CONNECTOR_TYPE_FLUINCY"
	| "CONNECTOR_TYPE_FOLLOW_UP_BOSS"
	| "CONNECTOR_TYPE_FOLLOW_UP_BOSS_OAUTH"
	| "CONNECTOR_TYPE_FORTNOX_OAUTH"
	| "CONNECTOR_TYPE_FOUNDATION_SOFT"
	| "CONNECTOR_TYPE_FULFIL"
	| "CONNECTOR_TYPE_FULFIL_3PL"
	| "CONNECTOR_TYPE_GENERIC_BASIC"
	| "CONNECTOR_TYPE_GETRESPONSE"
	| "CONNECTOR_TYPE_GITHUB"
	| "CONNECTOR_TYPE_GITLAB"
	| "CONNECTOR_TYPE_GLADLY"
	| "CONNECTOR_TYPE_GOHIGHLEVEL"
	| "CONNECTOR_TYPE_GONG"
	| "CONNECTOR_TYPE_GONG_OAUTH"
	| "CONNECTOR_TYPE_GOOGLE"
	| "CONNECTOR_TYPE_GOOGLE_GEMINI"
	| "CONNECTOR_TYPE_GOOGLE_SERVICE_ACCOUNT"
	| "CONNECTOR_TYPE_GOOTEN"
	| "CONNECTOR_TYPE_GORGIAS"
	| "CONNECTOR_TYPE_GORGIAS_OAUTH"
	| "CONNECTOR_TYPE_GREENHOUSE_IO_CANDIDATE_INGESTION"
	| "CONNECTOR_TYPE_GREENHOUSE_IO_HARVEST"
	| "CONNECTOR_TYPE_GREENHOUSE_IO_JOB_BOARD"
	| "CONNECTOR_TYPE_GWT"
	| "CONNECTOR_TYPE_HAPPYRETURNS"
	| "CONNECTOR_TYPE_HEARTLAND"
	| "CONNECTOR_TYPE_HOOTSUITE"
	| "CONNECTOR_TYPE_HOTSOS"
	| "CONNECTOR_TYPE_HS"
	| "CONNECTOR_TYPE_HUBSPOT_BASIC"
	| "CONNECTOR_TYPE_HUBSPOT_OAUTH"
	| "CONNECTOR_TYPE_HUGGING_FACE"
	| "CONNECTOR_TYPE_IMAGERELAY"
	| "CONNECTOR_TYPE_IMGUR"
	| "CONNECTOR_TYPE_ITERABLE"
	| "CONNECTOR_TYPE_JASPER"
	| "CONNECTOR_TYPE_JDP"
	| "CONNECTOR_TYPE_JUSTUNO"
	| "CONNECTOR_TYPE_KENTICO_KONTENT"
	| "CONNECTOR_TYPE_KLAUS"
	| "CONNECTOR_TYPE_KLAVIYO"
	| "CONNECTOR_TYPE_KLAVIYO_OAUTH"
	| "CONNECTOR_TYPE_KOMBO"
	| "CONNECTOR_TYPE_KUSTOMER"
	| "CONNECTOR_TYPE_KVCORE"
	| "CONNECTOR_TYPE_LAUNCHDARKLY_SDK"
	| "CONNECTOR_TYPE_LEAGUEAPPS"
	| "CONNECTOR_TYPE_LEAGUEAPPS_DEV1"
	| "CONNECTOR_TYPE_LESSONLY"
	| "CONNECTOR_TYPE_LEXOFFICE"
	| "CONNECTOR_TYPE_LINGA_ROS"
	| "CONNECTOR_TYPE_LINNWORKS"
	| "CONNECTOR_TYPE_LISTRAK_CROSS_CHANNEL"
	| "CONNECTOR_TYPE_LISTRAK_DATA"
	| "CONNECTOR_TYPE_LISTRAK_EMAIL"
	| "CONNECTOR_TYPE_LISTRAK_SMS"
	| "CONNECTOR_TYPE_LOOPRETURNS"
	| "CONNECTOR_TYPE_LOYALTY_LION"
	| "CONNECTOR_TYPE_LOYALTY_LION_OAUTH"
	| "CONNECTOR_TYPE_LUCIDTRAVEL"
	| "CONNECTOR_TYPE_LYTX"
	| "CONNECTOR_TYPE_LYTX_OAUTH2"
	| "CONNECTOR_TYPE_MAESTROQA"
	| "CONNECTOR_TYPE_MAGENTO_OAUTH"
	| "CONNECTOR_TYPE_MAILCHIMP"
	| "CONNECTOR_TYPE_MARKETO"
	| "CONNECTOR_TYPE_MEDALLIA"
	| "CONNECTOR_TYPE_MICROSOFT_ENTRA"
	| "CONNECTOR_TYPE_MINDBODY"
	| "CONNECTOR_TYPE_MINTSOFT"
	| "CONNECTOR_TYPE_MISTRAL_AI"
	| "CONNECTOR_TYPE_MOVO_AI"
	| "CONNECTOR_TYPE_NCSA"
	| "CONNECTOR_TYPE_NETOMI"
	| "CONNECTOR_TYPE_NETSUITE"
	| "CONNECTOR_TYPE_NEVERBOUNCE"
	| "CONNECTOR_TYPE_NICEREPLY"
	| "CONNECTOR_TYPE_NYLAS"
	| "CONNECTOR_TYPE_OMNISEND"
	| "CONNECTOR_TYPE_ONPAY"
	| "CONNECTOR_TYPE_ONPAY_SB1"
	| "CONNECTOR_TYPE_ONRAMP"
	| "CONNECTOR_TYPE_ONTRAPORT"
	| "CONNECTOR_TYPE_OPENAI"
	| "CONNECTOR_TYPE_OPTIMIZELY_DATA_PLATFORM"
	| "CONNECTOR_TYPE_PANDIUM"
	| "CONNECTOR_TYPE_PANDIUM_V2"
	| "CONNECTOR_TYPE_PAYCOM"
	| "CONNECTOR_TYPE_PERPLEXITY"
	| "CONNECTOR_TYPE_PERSONIO"
	| "CONNECTOR_TYPE_PERSPECTIVE"
	| "CONNECTOR_TYPE_PLAYERSHEALTH"
	| "CONNECTOR_TYPE_PLAYVOX"
	| "CONNECTOR_TYPE_PLEO"
	| "CONNECTOR_TYPE_POSTSCRIPT"
	| "CONNECTOR_TYPE_PROMOTER"
	| "CONNECTOR_TYPE_QBO"
	| "CONNECTOR_TYPE_QBO_BASIC"
	| "CONNECTOR_TYPE_QUALTRICS"
	| "CONNECTOR_TYPE_RECART"
	| "CONNECTOR_TYPE_RECHARGE"
	| "CONNECTOR_TYPE_RECURLY"
	| "CONNECTOR_TYPE_REPLICATE"
	| "CONNECTOR_TYPE_RETURNLY"
	| "CONNECTOR_TYPE_REVERSELOGIX"
	| "CONNECTOR_TYPE_RHUB"
	| "CONNECTOR_TYPE_RYDER_REDUX"
	| "CONNECTOR_TYPE_SAGE_INTACCT"
	| "CONNECTOR_TYPE_SAILTHRU"
	| "CONNECTOR_TYPE_SALESFORCE"
	| "CONNECTOR_TYPE_SALESFORCE_MARKETING_CLOUD"
	| "CONNECTOR_TYPE_SALESFORCE_PARDOT"
	| "CONNECTOR_TYPE_SCHEMATIC"
	| "CONNECTOR_TYPE_SENDGRID"
	| "CONNECTOR_TYPE_SENDLANE"
	| "CONNECTOR_TYPE_SEVENROOMS"
	| "CONNECTOR_TYPE_SFTP"
	| "CONNECTOR_TYPE_SHIPBOB"
	| "CONNECTOR_TYPE_SHIPHERO"
	| "CONNECTOR_TYPE_SHIPMONK"
	| "CONNECTOR_TYPE_SHIPPO"
	| "CONNECTOR_TYPE_SHIPSTATION"
	| "CONNECTOR_TYPE_SHOPIFY"
	| "CONNECTOR_TYPE_SKUBANA"
	| "CONNECTOR_TYPE_SKUBANA_DEMO"
	| "CONNECTOR_TYPE_SLACK_OAUTH"
	| "CONNECTOR_TYPE_SMARTRMAIL"
	| "CONNECTOR_TYPE_SMARTRR"
	| "CONNECTOR_TYPE_SMARTVATTEN"
	| "CONNECTOR_TYPE_SMILE_IO"
	| "CONNECTOR_TYPE_SOLIDUS"
	| "CONNECTOR_TYPE_SOURCE_CONTROL"
	| "CONNECTOR_TYPE_SPRINGBIG"
	| "CONNECTOR_TYPE_SQUARE"
	| "CONNECTOR_TYPE_SQUARE_SANDBOX"
	| "CONNECTOR_TYPE_STAMPED"
	| "CONNECTOR_TYPE_STELLACONNECT"
	| "CONNECTOR_TYPE_STRIPE"
	| "CONNECTOR_TYPE_SUGARCRM"
	| "CONNECTOR_TYPE_SUPABASE_DATA"
	| "CONNECTOR_TYPE_SUPABASE_DIRECT"
	| "CONNECTOR_TYPE_SWELL"
	| "CONNECTOR_TYPE_TALKABLE"
	| "CONNECTOR_TYPE_TEAMGENIUS"
	| "CONNECTOR_TYPE_TETHER"
	| "CONNECTOR_TYPE_THANKFUL"
	| "CONNECTOR_TYPE_TIKTOK"
	| "CONNECTOR_TYPE_TOAST_OAUTH"
	| "CONNECTOR_TYPE_TOGETHER_AI"
	| "CONNECTOR_TYPE_TRINET_B2B"
	| "CONNECTOR_TYPE_TRINET_END_USER"
	| "CONNECTOR_TYPE_TRIPLEWHALE"
	| "CONNECTOR_TYPE_TRUSTPILOT"
	| "CONNECTOR_TYPE_TRUSTPILOT_CLIENT"
	| "CONNECTOR_TYPE_TWILIO"
	| "CONNECTOR_TYPE_TWITTER_BASIC"
	| "CONNECTOR_TYPE_TWITTER_OAUTH"
	| "CONNECTOR_TYPE_UKG_PRO"
	| "CONNECTOR_TYPE_UNBABEL"
	| "CONNECTOR_TYPE_UPS"
	| "CONNECTOR_TYPE_UPSCRIBE"
	| "CONNECTOR_TYPE_USPS"
	| "CONNECTOR_TYPE_VISMA"
	| "CONNECTOR_TYPE_VISMA_NET"
	| "CONNECTOR_TYPE_WALMART"
	| "CONNECTOR_TYPE_WALMART_OAUTH"
	| "CONNECTOR_TYPE_WATTLINE"
	| "CONNECTOR_TYPE_WHIPLASH"
	| "CONNECTOR_TYPE_WHIPLASH_CLIENT"
	| "CONNECTOR_TYPE_WIX"
	| "CONNECTOR_TYPE_WORKMAX"
	| "CONNECTOR_TYPE_XERO"
	| "CONNECTOR_TYPE_YARDSTIK"
	| "CONNECTOR_TYPE_YOTPO"
	| "CONNECTOR_TYPE_ZENDESK_OAUTH"
	| "CONNECTOR_TYPE_ZEROBOUNCE"
	| "CONNECTOR_TYPE_ZINGTREE"
	| "CONNECTOR_TYPE_ZONOS"
	| "CONNECTOR_TYPE_ZOOM";

/**
 * Describes the enum integrations.v1.ConnectorType.
 */
export const ConnectorTypeSchema: GenEnum<ConnectorType, ConnectorTypeJson> = /*@__PURE__*/ enumDesc(file_integrations_v1_connector, 0);
